module.exports = __webpack_public_path__ + "static/img/lg-ess-img-02-03@w.e238e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-02-03@w.jpg
// module id = COLR
// module chunks = 0